import { ButtonFilter } from "../buttons";

const FilterSearch = (props) => {
  return (
    <div className="flex bg-white rounded-lg p-4 border border-tenken-gray-300">
      <div className="flex">{props.children}</div>
      <div className="self-end">
        <ButtonFilter
          className="mb-4"
          onClick={props.onSubmit}
          id={props?.id}
        >
          絞り込み
        </ButtonFilter>
      </div>
    </div>
  );
};

export default FilterSearch;
